import * as React from 'react';
export default function Icon({ icon, props, children }) {
    let iconNode;
    if (typeof icon === 'function') {
        iconNode = React.createElement(icon, Object.assign({}, props));
    }
    else {
        // Compatible for origin definition
        iconNode = icon;
    }
    return iconNode || children || null;
}
